const [ARHANDSHAKE, ENHANDSHAKE] = ["mhs_ar", "mhs_en"];
export const handshakeCookieName = (locale) =>
  locale === "ar" ? ARHANDSHAKE : ENHANDSHAKE;
export { ARHANDSHAKE, ENHANDSHAKE };
